import * as z from "zod";
import { upsertSkillFiles as upsertFiles } from "../skillFiles";
import { mutator } from "./mutator";

const upsertSkillFilesSchema = z.object({
  skillId: z.string(),
  files: z
    .array(
      z.object({
        path: z.string(),
        content: z.string(),
        encoding: z.enum(["utf8", "base64"]),
      })
    )
    .min(1),
});

export const upsertSkillFiles = mutator({
  redactKeys: ["content"],
  schema: upsertSkillFilesSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, ctx, args: { skill, files } }) => {
    await upsertFiles(
      tx,
      skill.id,
      ctx.tenantId,
      Object.fromEntries(
        files.map(({ path, content, encoding }) => [
          path,
          { content, encoding },
        ])
      )
    );
  },
});
